import { useCallback, useState } from 'react';
import { useApiServices } from '@shared/lib/use-api-services';
import {
  toCreateAccountingOperationPayload,
  type CreateOperationFormValues,
} from './lib/create-payload';

export type { CreateOperationFormValues };

export const useCreateAccountingOperation = () => {
  const services = useApiServices();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => setError(null), []);

  const createOperation = async (values: CreateOperationFormValues) => {
    setIsLoading(true);
    setError(null);

    try {
      await services.wallets.createOperation(toCreateAccountingOperationPayload(values));
      return { success: true as const };
    } catch (err: unknown) {
      const message =
        (err as { message?: string })?.message || 'Failed to create operation';
      setError(message);
      return { success: false as const, error: message };
    } finally {
      setIsLoading(false);
    }
  };

  return { createOperation, isLoading, error, clearError };
};
